import type { ReactNode } from 'react'
import { SurfaceThemeProvider } from './surfaceTheme'
import { useThemePreference } from './themePreference'

// Bleeds past <main>'s padding so the ground fills the whole content area
// (the sidebar stays as it is).
const BLEED = '-mx-4 -my-6 min-h-screen px-4 py-6 md:-mx-8 md:px-8'

/**
 * The Dashboard's "trading terminal" canvas, shared with Paper positions.
 *
 * Dark: the `dashboard-terminal` class switches on the `dark:` variants of
 * shared components rendered inside it (on every other page those follow
 * <html>'s theme-terminal). Light: `dashboard-light` instead, which
 * theme/light-theme.css uses to remap these dark-first pages onto the light
 * palette.
 */
const TerminalCanvas = ({ children }: { children: ReactNode }) => {
  const { resolved } = useThemePreference()
  return (
    <SurfaceThemeProvider value={resolved}>
      {resolved === 'dark' ? (
        <div className={`dashboard-terminal ${BLEED} bg-terminal-bg text-gray-100 [color-scheme:dark]`}>{children}</div>
      ) : (
        <div className={`dashboard-light ${BLEED} bg-[#F4F6FA] text-[#0F1A2B] [color-scheme:light]`}>{children}</div>
      )}
    </SurfaceThemeProvider>
  )
}

export default TerminalCanvas
